export const ngSelectConfigI18n = {
	fr: {
		notFoundText: 'Aucun résultat',
		typeToSearchText: 'Rechercher',
		addTagText: 'Ajouter',
		loadingText: 'Chargement...',
		clearAllText: 'Effacer'
	},
	en: {
		notFoundText: 'No items found',
		typeToSearchText: 'Type to search',
		addTagText: 'Add item',
		loadingText: 'Loading...',
		clearAllText: 'Clear all'
	}
};
